import { Link, useLocation } from 'react-router-dom';
import { usePermissions } from '@/api/permissions';
import { PHONE_SWITCHES } from '@/lib/navigation';
import { canOpen } from '@/lib/permissions';
import { MD_UP, useMediaQuery } from '@/lib/useMediaQuery';
import { cn } from '@/lib/utils';

/**
 * Phones: a segmented switch above My tickets ↔ Queues and My opps ↔ All opps, so the Tickets and Opps tabs are each
 * one combined screen. Options come from `PHONE_SWITCHES` (navigation.ts), filtered by the role (RBAC).
 */
export function PhoneSwitch() {
  const { pathname } = useLocation();
  const perms = usePermissions();
  const isDesktop = useMediaQuery(MD_UP);
  if (isDesktop) return null;
  const group = PHONE_SWITCHES.find((g) => g.some((o) => o.to === pathname));
  const options = group?.filter((o) => canOpen(perms, o.to)) ?? [];
  if (options.length < 2) return null;
  return (
    <div className="sticky top-0 z-20 border-b border-border bg-background/95 px-4 py-2 backdrop-blur">
      <div className="flex rounded-lg bg-muted p-0.5" role="tablist">
        {options.map((o) => (
          <Link key={o.to} to={o.to} replace role="tab" aria-selected={o.to === pathname}
            className={cn('flex-1 rounded-md py-1.5 text-center text-sm font-medium transition-colors',
              o.to === pathname ? 'bg-background text-foreground shadow-sm' : 'text-muted-foreground')}>
            {o.label}
          </Link>
        ))}
      </div>
    </div>
  );
}
